/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_DescriptionInputs */

const cs_projects_description = /** @type {(inputs: Projects_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popis`)
};

const en_projects_description = /** @type {(inputs: Projects_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {Projects_DescriptionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_description = /** @type {((inputs?: Projects_DescriptionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_DescriptionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_description(inputs)
	return cs_projects_description(inputs)
});